// extracted by mini-css-extract-plugin
export default {"bokeh-animation-box":"BokehAnimationBox_bokeh-animation-box__x-2BI","move":"BokehAnimationBox_move__xeavp","secondary":"BokehAnimationBox_secondary__o9O8F"};